import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
} from "@material-ui/core";

interface IRecord {
  description: string;
  status: string;
}

interface ITableResultCsvFileUpload {
  records: IRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
});

const TableResultCsvFileUpload = ({ records }: ITableResultCsvFileUpload) => {
  const classes = useStyles();
  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record: IRecord, key: number) => {
            return (
              <TableRow key={`row-${key}`}>
                <TableCell>{record.description}</TableCell>
                <TableCell>{record.status}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultCsvFileUpload;
